import { useQuery } from "react-query";
import { getClassroomTypes } from "../services/school/classroom/classroom";
import { PagedRequestType } from "../types/PagedResults";
import { Key_classroomtypes } from "../utils/constants";

export const useGetClassroomTypesQuery = (data: PagedRequestType, options:any = null) =>
  useQuery(
    [Key_classroomtypes, JSON.stringify(data)],
    () => getClassroomTypes(data), 
    options?{...options}:{}
  );